import { render, staticRenderFns } from "./PrivacyIcon.vue?vue&type=template&id=0304cf91"
import script from "./PrivacyIcon.vue?vue&type=script&lang=js"
export * from "./PrivacyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports